import { useEffect, useState, useMemo} from "react";
import { Container } from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import DataTable from 'react-data-table-component';
import ShowTime from "../../../utils/ShowTime/ShowTime";
import { Button } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import countryList from 'react-select-country-list';
import Select from 'react-select'
import CustomLoader from "../../../utils/DataTableLoader/CustomLoader";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Can, useAuth } from "../../../authentication/AuthContext";
import TruncatedText, { TruncatedTextTooltip, DateCell, COLUMN_WIDTHS } from "../../../Components/TruncatedText/TruncatedText";


export default function TrialVerificationCodes() {
  const { can } = useAuth();
  const navigate = useNavigate();

  const [TableData,setTableData]= useState([]);
  const [screenloader,setScreenloader] = useState(true);
  const [TotalRecords,setTotalRecords] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(1);
  const [sortBy,setSortBy] = useState('created_at');
  const [sortOrder,setSortOrder] = useState('desc');
  const [pending, setPending] = useState(true);

   //filters
   const initialFilters = {
    last_seen: { operator: '', value: '' },
    status: { operator: '', value: '' },
    'l.created_at': { operator: '', value: '' },
    'l.expires_at': { operator: '', value: '' },
    email: { operator: '', value: '' },
    product_id: { operator: '', value: '' },
    organization: { operator: '', value: '' }
  };
  const [filters, setFilters] = useState(initialFilters);
  const [createdAt, setCreatedAt] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [email, setEmail] = useState("");
  const [organization , setOrganization] = useState("");
  const [country, setCountry] = useState([]);
  const CountriesList = useMemo(() => countryList().getData(), []);
  
  const handleFiltersChange = (key, value, operator) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [key]: {
        operator: operator,
        value: value
      }
    }));
  };

  const handleFiltersReset = () =>{
    setFilters(initialFilters);
    setCreatedAt("");
    setExpiresAt("");
    setEmail("");
    setOrganization("");
    setCountry([]);
  }


  const handleEnterKeyPress = (e) => {
      var value =e.target.value;
      if(value!==""){
        value = `%${value}%`
      }
      if (e.key === 'Enter') {
        handleFiltersChange(e.target.id, value, 'LIKE')    
      }
  };

  const handleCopyEmailList = () =>{
    const emails = Array.from(new Set(TableData.map(license => license.email)));
    const emailList = emails.join(', ');
    try {
      navigator.clipboard.writeText(emailList);
      toast.success(`${emails.length} Emails copied to clipboard!`);
    } catch (error) {
      toast.error('Failed to copy email list to clipboard');
    }
  };


  const columns = [
    { 
      name: "Actions", 
      // Hidden entirely rather than left as an empty column: omit drops the
      // header as well as the cells.
      omit: !(can('admin.verification_codes.trial_delete')),
      sortable: false, 
      cell: row => (
        <div>
          <Can permission="admin.verification_codes.trial_delete">
            <FaTrashAlt
              data-tooltip-id={`delete-${row.id}`}
              data-tooltip-content="Delete Verification Code"
              className="edit-icon"
              onClick={() => handleDelete(row.id)}
            />
          </Can>
        </div>
      )
    },
    {
      name: 'ID',
      selector: row => (row.id),
      sortField: "id",
      sortable: true,
      cell: row=>(<div style={{ whiteSpace: 'pre-wrap' }}>{row.id}</div>),
    },
    {
      name: 'PID',
      minWidth: `${COLUMN_WIDTHS.refId}px`,
      selector: row => (row.pid),
      sortField: "pid",
      sortable: true,
      cell: row => <TruncatedText text={row.pid} maxWidth={COLUMN_WIDTHS.refId} mono />,
    },
    {
      name: 'Product Version',
      selector: row => (row.product_version),
      sortField: "product_version",
      sortable: true,
      cell: row => <div>{row.product_version ? row.product_version : '-'}</div>,
    },
    {
      name: 'Machine ID',
      minWidth: `${COLUMN_WIDTHS.machine}px`,
      selector: row => (row.machine_id),
      sortField: "machine_id",
      sortable: true,
      cell: row => <TruncatedText text={row.machine_id} maxWidth={COLUMN_WIDTHS.machine} mono />,
    },
    {
      name: 'Machine User',
      minWidth: `${COLUMN_WIDTHS.machine}px`,
      selector: row => (row.machine_user),
      sortField: "machine_user",
      sortable: true,
      cell: row => <TruncatedText text={row.machine_user} maxWidth={COLUMN_WIDTHS.machine} />,
    },
    {
      name: 'Verification Code',
      selector: row => row.verification_code,
      sortField: "verification_code",
      sortable: true,
      cell: row => <div><code>{row.verification_code}</code></div>,
    },
    {
      name: 'First Name',
      minWidth: `${COLUMN_WIDTHS.name}px`,
      selector: row => row.fname,
      sortField: "fname",
      sortable: true,
      cell: row => <TruncatedText text={row.fname} maxWidth={COLUMN_WIDTHS.name} />,
    },
    {
      name: 'Last Name',
      minWidth: `${COLUMN_WIDTHS.name}px`,
      selector: row => row.lname,
      sortField: "lname",
      sortable: true,
      cell: row => <TruncatedText text={row.lname} maxWidth={COLUMN_WIDTHS.name} />,
    },
    {
      name: 'Email',
      minWidth: `${COLUMN_WIDTHS.email}px`,
      selector: row => row.email,
      sortField: "email",
      sortable: true,
      cell: row => <TruncatedText text={row.email} maxWidth={COLUMN_WIDTHS.email} />,
    },
    {
      name: 'Phone',
      minWidth: `${COLUMN_WIDTHS.phone}px`,
      selector: row => row.phone,
      sortField: "phone",
      sortable: true,
      cell: row => <TruncatedText text={row.phone} maxWidth={COLUMN_WIDTHS.phone} />,
    },
    {
      name: 'Country',
      minWidth: `${COLUMN_WIDTHS.country}px`,
      selector: row => row.country,
      sortField: "country",
      sortable: true,
      cell: row => <TruncatedText text={row.country} maxWidth={COLUMN_WIDTHS.country} />,
    },
    {
      name: 'Organization',
      minWidth: `${COLUMN_WIDTHS.organization}px`,
      selector: row => row.organization,
      sortField: "organization",
      sortable: true,
      cell: row => <TruncatedText text={row.organization} maxWidth={COLUMN_WIDTHS.organization} />,
    },
    {
      name: 'Created At',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.created_at,
      sortField: "created_at",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.created_at)} />,
    },
    {
      name: 'Updated At',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.updated_at,
      sortField: "updated_at",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.updated_at)} />,
    },
    {
      name: 'Expires At',
      minWidth: `${COLUMN_WIDTHS.date}px`,
      selector: row => row.expires_at,
      sortField: "expires_at",
      sortable: true,
      cell: row => <DateCell value={ShowTime(row.expires_at)} />,
    },
    {
      name: 'Attempt No.',
      selector: row => (row.attempt_no),
      sortField: "attempt_no",
      sortable: true,
      cell: row=>(<div style={{ whiteSpace: 'pre-wrap' }}>{row.attempt_no}</div>),
    },
    
  ];

  const getUsersList = async () => {
    // console.log(page,pageSize,sortBy,sortOrder,filters)
    try {
      const formattedFilters = Object.keys(filters)
      .filter(key => filters[key].value) // Filter out falsy values
      .map((key, index) => ({
        [`filters[${index}][column]`]: key,
        [`filters[${index}][operator]`]: filters[key].operator,
        [`filters[${index}][value]`]: filters[key].value,
      }))
      .reduce((acc, obj) => ({ ...acc, ...obj }), {});

      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/verification_codes/trial`, {
        params: {
          limit: pageSize,
          page: page,
          sort_by:sortBy,
          sort_order:sortOrder,
          ...formattedFilters
        },
        headers: {
          'access-token': localStorage.getItem('accessToken'),
        },
      });
      setScreenloader(false);
      setPending(false);
      if (response.data.status) {
        const total = response.data.meta.pagination.total;
        setTotalRecords(total);
        setTableData(response.data.verification_codes);
      } else {
        toast.error('Something Went Wrong');
        console.log(response.data);
      }
    } catch (error) {
      setScreenloader(false);
      setPending(false);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        console.error(error);
        toast.error('Something Went Wrong');
      }
    }
  };
  const handleDelete = async (id) => {
    confirmAlert({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this verification code?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              const response = await axios.delete(`${process.env.REACT_APP_API_URL}/admin/verification_codes/trial/${id}`, {
                headers: {
                  'access-token': localStorage.getItem('accessToken'),
                },
              });
              
              if (response.data.status) {
                toast.success('Verification code deleted successfully');
                getUsersList(); // Refresh the table
              } else {
                toast.error('Failed to delete verification code');
              }
            } catch (error) {
              if (error.response?.data?.message) {
                toast.error(error.response.data.message);
              } else {
                console.error(error);
                toast.error('Something went wrong');
              }
            }
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };
  useEffect(() => {
    setPending(true);
    getUsersList();
  }, [filters, page, pageSize, sortBy, sortOrder]);
 

  const now = new Date();

  const startOfDay = new Date(now);
  startOfDay.setHours(0, 0, 0, 0);

  const startOf3DaysAgo = new Date(now);
  startOf3DaysAgo.setDate(startOf3DaysAgo.getDate() - 2);
  startOf3DaysAgo.setHours(0, 0, 0, 0);

  const endOf3DaysAfter = new Date(now);
  endOf3DaysAfter.setDate(endOf3DaysAfter.getDate() + 3);
  endOf3DaysAfter.setHours(0, 0, 0, 0);

  const startOf1WeekAgo = new Date(now);
  startOf1WeekAgo.setDate(startOf1WeekAgo.getDate() - 7);
  startOf1WeekAgo.setHours(0, 0, 0, 0);

  const endOf1WeekAfter = new Date(now);
  endOf1WeekAfter.setDate(endOf1WeekAfter.getDate() + 7);
  endOf1WeekAfter.setHours(0, 0, 0, 0);

  const startOf1MonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
  startOf1MonthAgo.setHours(0, 0, 0, 0);

  const endOf1MonthAfter = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
  endOf1MonthAfter.setHours(0, 0, 0, 0);

  const startOf2MonthAgo = new Date(now.getFullYear(), now.getMonth() - 2, now.getDate());
  startOf2MonthAgo.setHours(0, 0, 0, 0);

  const endOf2MonthAfter = new Date(now.getFullYear(), now.getMonth() + 2, now.getDate());
  endOf2MonthAfter.setHours(0, 0, 0, 0);

  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>

            <div className="row">
              <h2>Trial Verification Codes</h2>
            </div>

            <div className="filters row">
              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder='Email'
                      value={email}
                      onChange={e =>{setEmail(e.target.value);}}
                      onKeyDown={handleEnterKeyPress}
                  />
                  {email && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'email', value: email } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-3 mb-3">
                <div className="input-group">
                  <input
                      type="text"
                      className="form-control"
                      id="organization"
                      placeholder='Organization'
                      value={organization}
                      onChange={e =>{setOrganization(e.target.value);}}
                      onKeyDown={handleEnterKeyPress}
                  />
                  {organization && (
                    <span
                      className="input-group-text"
                      role="button"
                      onClick={() => handleEnterKeyPress({ key: 'Enter', target: { id: 'organization', value: organization } })}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>


              <div className="col-md-3 mb-3">
                <Select placeholder="Country" options={CountriesList} value={country} onChange={(e) => {setCountry(e);handleFiltersChange('country', e.label, '=')}} />
              </div>

              <div className="col-md-3 mb-3">
                <Select
                  placeholder="Created At"
                  options={[
                      { value: "", label:"All" },
                      { value: startOfDay.toISOString(), label:"Today" },
                      { value: startOf3DaysAgo.toISOString(), label: "Past 3 Days" },
                      { value: startOf1WeekAgo.toISOString(), label: "Within a Week" },
                      { value: startOf1MonthAgo.toISOString(), label:"Witin a Month" },
                      { value: startOf2MonthAgo.toISOString(), label:"Within 2 Months" },
                  ]}
                  value={createdAt}
                  onChange={(e) => {setCreatedAt(e);handleFiltersChange('created_at', e.value, '>=')}}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6 col-md-6 mb-3 d-flex">
                <Button onClick={handleCopyEmailList} variant="primary" className="admin-btn">
                  Copy Email List
                </Button>
              </div>
              <div className="col-6 col-md-6 mb-3 d-flex justify-content-end align-items-end">
                <Button onClick={handleFiltersReset} variant="primary" className="admin-btn">
                  Clear all Filters
                </Button>
              </div>
            </div>
            <div className="row d-flex d-sm-none">
              <p>Total Records: <strong>{TotalRecords}</strong></p>
            </div>

            <div className="table-wrapper">
              <DataTable
                //data
                columns={columns}
                data={TableData}
                //style
                dense
                direction="auto"
                highlightOnHover
                noHeader
                persistTableHead
                pointerOnHover
                responsive
                subHeaderAlign="right"
                subHeaderWrap
                progressPending={pending}
                progressComponent={<CustomLoader />}
                // conditionalRowStyles={conditionalRowStyles}
                //pagination
                pagination
                paginationServer 
                paginationPerPage={pageSize} 
                paginationTotalRows={TotalRecords} 
                paginationRowsPerPageOptions={[10,20,50,100,150]}
                onChangePage={(page) => setPage(page)} 
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {setPageSize(currentRowsPerPage); setPage(currentPage)}} 
                sortServer
                onSort={(column, sortDirection) => {setSortBy(column.sortField); setSortOrder(sortDirection);}}
              />
            </div>
          </div>
        </div>
      </div>
      <TruncatedTextTooltip />
    </div>
  );
}